import { render, staticRenderFns } from "./UploadDocuments.vue?vue&type=template&id=41cac13f&scoped=true&lang=pug&"
import script from "./UploadDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocuments.vue?vue&type=style&index=0&id=41cac13f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cac13f",
  null
  
)

export default component.exports